module.exports = __webpack_public_path__ + "img/EMC-alt.908c3926.svg";